export default {
    name: 'Whiteroad',
    logoVariant: 'dark',
    logo: {
        square: '/src/brands/whiteroad/assets/square.png',
    },
    pwa: {
        name: 'Whiteroad Resort Management',
        shortName: 'Whiteroad Reps',
        themeColor: '#919ea6',
        backgroundColor: '#ffffff',
        icon: '/src/brands/whiteroad/assets/icon.png',
        vapidPublicKey: 'BO6LHTcktRG1xwi5WAKtKKzmOy-Y4v1rr0Etqw8gXY5vYolkQATa1iHs_pq44R8XVOGm1UaI-lurI_ggeZQxv2E'
    }
}